import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to build resilience.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>We all know how resilient weeds can be. They just keep coming
                                                back regardless of how hard we dig.</p>


                                            <div className="border_subtitle">Deliver every time</div>
                                            <div className="paraspace"><p>This ‘bouncebackability’ is proof that
                                                nature shows resilience to even some of the toughest
                                                conditions. In the same way, work can be tough, drain our energy
                                                and occasionally leave us
                                                feeling demotivated and tired. The pace and nature of the
                                                contemporary workplace is such that
                                                we all need to understand how to take care of ourselves to deal
                                                with demanding workloads. A
                                                psychologist named Hans Selye<a className="superscripttext "
                                                                                href="further_info.php?course=300"><sup>1</sup></a> nicely
                                                captured people’s responses to work pressures as
                                                capacity, demand, adaptation. As humans, we are very adaptable
                                                and some of us cope better than
                                                others with stress and pressure. The study below explored our
                                                perceptions of how hardy we are:</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">The power of positive thought
                                                </div>
                                                <p className="supLinesapce">Jason Riis and his colleagues<a
                                                    className="superscripttext "
                                                    href="further_info.php?course=300"><sup>2</sup></a> investigated
                                                    how resilient we are likely to feel if faced with
                                                    a life threatening situation, such as having a terminal
                                                    illness. They asked patients who had
                                                    end stage kidney illnesses and some ‘healthy’ people to
                                                    record their mood every 90
                                                    minutes by pocket computer for a week.</p>
                                                <div className="uiheading"><p>Surprisingly, the average ratings
                                                    for both groups were equally positive but when interviewed,
                                                    the healthy participants predicted that their mood would be
                                                    negative most of the time if
                                                    they had chronic kidney illness. Conversely, the patients
                                                    predicted that they would feel
                                                    much more positive if they had never had a kidney illness.
                                                    So both groups appeared to
                                                    underestimate the resilience of people’s mood to
                                                    illness.</p></div>
                                            </div>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>Like weeds in a garden, there are many occasions in life where we
                                                experience setbacks and have
                                                to bounce back in the face of adversity. This tool is all
                                                about <span className="brown brownbold">how to build and maintain resilience</span>
                                                in order to overcome these obstacles and helps to explore what
                                                resilience means and help you to
                                                understand how you can deal with difficult situations more
                                                effectively.</p>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}